import script from "./ExternalUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalUsers.vue?vue&type=script&setup=true&lang=js"

import "./ExternalUsers.vue?vue&type=style&index=0&id=808dac30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-808dac30"]])

export default __exports__